import { Injectable } from '@angular/core';
import { TabValues } from 'app/modules/common/entities/tab-value.model';

@Injectable({
  providedIn: 'root'
})
export class UserManagementViewService {

  public managementTabList = new Array<TabValues>();

  public editBtn: boolean = true;
  public saveBtn: boolean = false;
  public undoBtn: boolean = false;
  public deleteBtn: boolean = false;
  public hideUserArea: boolean = true;
  public buttonDisabled: boolean = false
  public tipoList;

  constructor() {
  }

  /**
   * For users panel
   * @param editBtn 
   * @param saveBtn 
   * @param undoBtn 
   * @param deleteBtn 
   * @param hideUserArea 
   * @param buttonDisabled 
   */
  public setView(editBtn?: boolean, saveBtn?: boolean, undoBtn?: boolean, deleteBtn?: boolean, hideUserArea?: boolean, buttonDisabled?: boolean) {
    //set and disable user buttons and panel
    this.editBtn = editBtn != null ? editBtn : this.editBtn;
    this.saveBtn = saveBtn != null ? saveBtn : this.saveBtn;
    this.undoBtn = undoBtn != null ? undoBtn : this.undoBtn;
    this.deleteBtn = deleteBtn != null ? deleteBtn : this.deleteBtn;
    this.hideUserArea = hideUserArea != null ? hideUserArea : this.hideUserArea;
    this.buttonDisabled = buttonDisabled != null ? buttonDisabled : this.buttonDisabled
  }

  /**
   * Permission panel
   */
  public initManagementTabs(): void {
    this.managementTabList = [
      { id: 1, isPermit: true, viewValue: 'Empresa' , value : 'EMPRESA'},
      { id: 2, isPermit: true, viewValue: 'Médico'  , value : 'MEDICO'},
      { id: 3, isPermit: true, viewValue: 'Selección' , value : 'SELECCION' },
      { id: 4, isPermit: true, viewValue: 'Trabajador' , value : 'TRABAJADOR' },
      { id: 5, isPermit: true, viewValue: 'Baja' , value : 'BAJA' },
      { id: 6, isPermit: true, viewValue: 'Actuación' , value : 'ACTUACION' },
      { id: 7, isPermit: true, viewValue: 'Operación' , value : 'OPERACION' },
      { id: 8, isPermit: true, viewValue: 'Facturación' , value : 'FACTURACION' },
      { id: 9, isPermit: true, viewValue: 'Gestión' , value : 'GESTION' },
      { id: 10, isPermit: true, viewValue: 'Listados' , value : 'LISTADO' }
    ];
  }

  public getTipoList() {
    this.tipoList = [
      { viewValue: 'Principal', value: 'P' },
      { viewValue: 'Aditivo', value: '+' },
      { viewValue: 'Restrictivo', value: '-' },
    ];
  }
}
